import React, { type FunctionComponent, useMemo } from 'react'
import { css, type SerializedStyles } from '@emotion/react'
import { Link } from 'react-router-dom'
import { useTDSContext, typography } from '../../tds/index'
import { colors, fontSize, fontWeight } from '../../foundation'

const breadcrumbStyles = css({
  fontSize: fontSize.X18,
  fontWeight: fontWeight.BOLD,
})

const linkStyles = (useTDS: boolean) =>
  css({
    color: '#000000',
    ':visited': {
      color: 'inherit',
    },
    ':hover': {
      color: useTDS ? colors.PRIMARY_TDS.REGULAR : colors.PRIMARY.REGULAR,
    },
  })

interface Props {
  path?: string
  additionalLinkStyle?: SerializedStyles
  className?: string
}

export const Breadcrumb: FunctionComponent<React.PropsWithChildren<Props>> = ({
  children,
  path,
  additionalLinkStyle,
  ...rest
}) => {
  const { useTDS } = useTDSContext()
  const content = useMemo(() => {
    if (!path) return children

    return (
      <Link css={[linkStyles(useTDS), additionalLinkStyle]} to={path}>
        {children}
      </Link>
    )
  }, [children, path, additionalLinkStyle, useTDS])

  return (
    <div css={useTDS ? css(typography.subtitle) : breadcrumbStyles} {...rest}>
      {content}
    </div>
  )
}
